import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SelectionRabItemMenuItem } from './SelectionRabCorrectScoreMenuItem.style';
import { slug } from 'src/utils/deburr';
// eslint-disable-next-line no-restricted-imports
import { useAsObservableSource } from 'mobx-react-lite';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface SelectionRabPropsType {
    isActive: boolean;
    name: string;
    changeActiveMenu: (activeMenu: string) => void;
}

class State {
    public constructor(private readonly props: SelectionRabPropsType) {}

    public changeMenu = (): void => {
        const slugName = slug(this.props.name);
        this.props.changeActiveMenu(slugName);
    };
}

export const SelectionRabNestedMenuItem = observer('SelectionRabNestedMenuItem', (propsIn: SelectionRabPropsType) => {
    const props = useAsObservableSource(propsIn);
    const { name, isActive } = props;
    const [state] = React.useState(() => new State(props));
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    return (
        <SelectionRabItemMenuItem
            onClick={state.changeMenu}
            isActive={isActive}
            variant={configState.componentVariants.sportsbookVariant}
        >
            {name}
        </SelectionRabItemMenuItem>
    );
});
